//cart

export const POST_CART_REQUEST = "POST_CART_REQUEST";
export const POST_CART_SUCCESS = "POST_CART_SUCCESS";
export const POST_CART_FAILURE = "POST_CART_FAILURE";

export const GET_CART_REQUEST = "GET_CART_REQUEST";
export const GET_CART_SUCCESS = "GET_CART_SUCCESS";
export const GET_CART_FAILURE = "GET_CART_FAILURE";

export const DELETE_CART_REQUEST = "DELETE_CART_REQUEST";
export const DELETE_CART_SUCCESS = "DELETE_CART_SUCCESS";
export const DELETE_CART_FAILURE = "DELETE_CART_FAILURE";

//wishlist

export const POST_WISHLIST_REQUEST = "POST_WISHLIST_REQUEST";
export const POST_WISHLIST_SUCCESS = "POST_WISHLIST_SUCCESS";
export const POST_WISHLIST_FAILURE = "POST_WISHLIST_FAILURE";

export const GET_WISHLIST_REQUEST = "GET_WISHLIST_REQUEST";
export const GET_WISHLIST_SUCCESS = "GET_WISHLIST_SUCCESS";
export const GET_WISHLIST_FAILURE = "GET_WISHLIST_FAILURE";

export const DELETE_WISHLIST_REQUEST = "DELETE_WISHLIST_REQUEST";
export const DELETE_WISHLIST_SUCCESS = "DELETE_WISHLIST_SUCCESS";
export const DELETE_WISHLIST_FAILURE = "DELETE_WISHLIST_FAILURE";

export const UNIQUE_CART = "UNIQUE_CART";
export const UNIQUE_WISHLIST = "UNIQUE_WISHLIST";

export const EMPTY_CART_REQUEST = "EMPTY_CART_REQUEST";
export const EMPTY_CART_SUCCESS = "EMPTY_CART_SUCCESS";
export const EMPTY_CART_FAILURE = "EMPTY_CART_FAILURE";
